import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';

const websiteContents3URL = "https://charityph-website-content.s3.ap-southeast-1.amazonaws.com/";
const projectImagess3URL = "https://charity-project-images.s3.ap-southeast-1.amazonaws.com";

const imageStyle = (imageUrl) => {
  return {
    height: { xs: 140, md: 340 },
    backgroundImage: `url(${imageUrl})`,
    background: `linear-gradient(0deg, rgba(0,0,0, 0.3), rgba(0,0,0, 0.3)),url(${imageUrl})`,
    boxShadow: 1,
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    // '&:hover': {
    //   cursor: 'zoom-in',
    // },
  };
};

CharityHeader.propTypes = {
  charity: PropTypes.shape({
    bannerImages: PropTypes.array,
  }),
};

export default function CharityHeader({ charity }) {
  const bannerImages = charity?.charityDetails?.bannerImages[0];
  let imageUrl = '';
  if(bannerImages)
  imageUrl = bannerImages.includes('https') ? bannerImages : bannerImages.includes('images/charities') ? websiteContents3URL + bannerImages : projectImagess3URL + bannerImages ; // eslint-disable-line no-nested-ternary
  return <Box sx={imageStyle(`'${imageUrl}'`)} />;
  // return <Box sx={imageStyle(`${s3URL}${bannerImages[0]}`)} />;

}
